/**
 * Brand icons for cloud providers and IaC languages.
 * Inline SVGs (16x16 by default) so we don't add an icon dependency.
 */
import React from "react";

const AzureLogo = ({ className = "" }) => (
  <svg
    viewBox="0 0 32 32"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="az-a" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#114A8B" />
        <stop offset="1" stopColor="#0669BC" />
      </linearGradient>
      <linearGradient id="az-b" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stopColor="#3CCBF4" />
        <stop offset="1" stopColor="#2892DF" />
      </linearGradient>
    </defs>
    <path fill="url(#az-a)" d="M14 3.5h6L11 26.5H5.2c-1.4 0-2.2-1.6-1.4-2.7L14 3.5z" />
    <path fill="#0078D4" d="M15 20 6.5 30h20.7c1.2 0 2-1.3 1.4-2.4L21.5 15l-6.5 5z" />
    <path fill="url(#az-b)" d="M22 3.5h-8l14.6 25.9c.7 1.1 2.3 1.1 2.9 0L23.4 5.9c-.3-1-1.2-2.4-1.4-2.4z" />
  </svg>
);

const AwsLogo = ({ className = "" }) => (
  <svg
    viewBox="0 0 32 32"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path fill="#252F3E" d="M9.7 15.6c0 .4 0 .7.1 1 .1.2.2.5.4.8l.1.3-.6.4-.2-.1-.5-.7c-.7.8-1.5 1.2-2.5 1.2-.7 0-1.3-.2-1.7-.6-.4-.4-.6-1-.6-1.7 0-.7.3-1.3.8-1.8s1.2-.6 2.1-.6c.3 0 .6 0 .9.1.3 0 .7.1 1 .2v-.7c0-.7-.1-1.1-.4-1.4-.3-.3-.8-.4-1.5-.4-.3 0-.6 0-1 .1-.3.1-.7.2-1 .3-.1 0-.2.1-.3.1h-.1c-.1 0-.2-.1-.2-.2v-.5c0-.1 0-.2.1-.3.1-.1.2-.1.3-.2.3-.1.7-.3 1.1-.4.4-.1.9-.2 1.4-.2 1 0 1.8.2 2.2.7s.7 1.2.7 2.2v2.7zm-3.6 1.3c.3 0 .6-.1.9-.2.3-.1.6-.3.9-.5l.3-.3.1-.5v-.6c-.2-.1-.5-.1-.8-.1s-.5-.1-.8-.1c-.6 0-1 .1-1.3.3s-.4.5-.4 1c0 .4.1.7.3.9.3.1.5.2.8.1z" />
    <path fill="#F90" d="M26.5 21.7c-3 2.2-7.4 3.4-11.2 3.4-5.3 0-10.1-2-13.7-5.3-.3-.3 0-.6.3-.4 3.9 2.3 8.7 3.6 13.7 3.6 3.4 0 7.1-.7 10.5-2.2.5-.2 1 .3.4.9z" />
    <path fill="#F90" d="M27.7 20.4c-.4-.5-2.5-.2-3.5 0-.3 0-.4-.2-.1-.4 1.7-1.2 4.4-.8 4.7-.4.3.4-.1 3.1-1.6 4.4-.2.2-.5.1-.4-.2.3-.9 1.3-3 .9-3.4z" />
  </svg>
);

const GcpLogo = ({ className = "" }) => (
  <svg
    viewBox="0 0 32 32"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path fill="#4285F4" d="M20.9 12.5h.6l3.4-3.4.2-1.5A15 15 0 0 0 4 14.9c.3-.2 1.7-.3 1.7-.3l6.8-1.1s.4-.6.5-.5a8.3 8.3 0 0 1 8-.5z" />
    <path fill="#34A853" d="M27 14.9a15 15 0 0 0-4.5-7.3l-4.8 4.8a8.3 8.3 0 0 1 3 6.6v.8a4.2 4.2 0 0 1 0 8.3H16l-.8.8v5l.8.7h5a10.9 10.9 0 0 0 6-19.7z" />
    <path fill="#FBBC05" d="M10.7 27.5h5.3v-5l-1-.9c-4 0-3.7 0-4.3-.4-1.3-.7-2-1.9-2-3.6l1-3.7-4.4-.4A11.3 11.3 0 0 0 10.7 27.5z" />
    <path fill="#EA4335" d="M16 8.3c-3.5.1-6.6 1.7-8.7 4.6L11 16.5A4.3 4.3 0 0 1 16 13c.2 0 .3 0 .4.1L21 8.6l-.2-.3A11.4 11.4 0 0 0 16 8.3z" />
  </svg>
);

const TerraformLogo = ({ className = "" }) => (
  <svg
    viewBox="0 0 32 32"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path fill="#7B42BC" d="M12.5 10 20 14.3v8.6L12.5 18.6z" />
    <path fill="#7B42BC" opacity=".8" d="M20.9 14.3 28.4 10v8.6l-7.5 4.3z" />
    <path fill="#7B42BC" opacity=".6" d="M3.6 5v8.6l7.5 4.3V9.3z" />
    <path fill="#7B42BC" d="M12.5 19.9 20 24.2v5.4l-7.5-4.3z" />
  </svg>
);


const BicepLogo = ({ className = "" }) => (
  <svg
    viewBox="0 0 32 32"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="bi-a" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#4EB5F6" />
        <stop offset="1" stopColor="#0078D4" />
      </linearGradient>
    </defs>
    <path
      fill="url(#bi-a)"
      d="M16 3 4 10v12l12 7 12-7V10L16 3zm0 3.6 8.2 4.8-8.2 4.7-8.2-4.7L16 6.6zm-9 6.2 8 4.6v8.3l-8-4.6v-8.3zm18 0v8.3l-8 4.6V17.4l8-4.6z"
    />
  </svg>
);

export function CloudIcon({ cloud, className = "h-4 w-4" }) {
  const c = (cloud || "").toLowerCase();
  if (c === "azure") return <AzureLogo className={className} />;
  if (c === "aws") return <AwsLogo className={className} />;
  if (c === "gcp") return <GcpLogo className={className} />;
  return null;
}

export function LangIcon({ language, className = "h-4 w-4" }) {
  const l = (language || "").toLowerCase();
  if (l === "terraform") return <TerraformLogo className={className} />;
  if (l === "bicep") return <BicepLogo className={className} />;
  return null;
}

const GitHubLogo = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path fill="currentColor" d="M12 .3a12 12 0 0 0-3.8 23.4c.6.1.8-.3.8-.6v-2c-3.3.7-4-1.6-4-1.6-.6-1.4-1.4-1.8-1.4-1.8-1-.7.1-.7.1-.7 1.2.1 1.8 1.2 1.8 1.2 1 1.8 2.8 1.3 3.5 1 .1-.8.4-1.3.7-1.6-2.7-.3-5.5-1.3-5.5-5.9 0-1.3.5-2.4 1.2-3.2-.1-.3-.5-1.5.1-3.2 0 0 1-.3 3.3 1.2a11.5 11.5 0 0 1 6 0c2.3-1.5 3.3-1.2 3.3-1.2.7 1.7.2 2.9.1 3.2.8.8 1.2 1.9 1.2 3.2 0 4.6-2.8 5.6-5.5 5.9.4.4.8 1.1.8 2.2v3.3c0 .3.2.7.8.6A12 12 0 0 0 12 .3z" />
  </svg>
);

const GitLabLogo = ({ className = "" }) => (
  <svg viewBox="0 0 32 32" className={className} xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path fill="#E24329" d="m30.7 13-.1-.1-4-10.6a1 1 0 0 0-1-.7 1 1 0 0 0-1 .8l-2.7 8.4h-11L8 2.4a1 1 0 0 0-1-.8 1 1 0 0 0-1 .7l-4 10.6v.1a7.6 7.6 0 0 0 2.5 8.7l6.9 5.2 3.4 2.6 2.1 1.6a1.4 1.4 0 0 0 1.7 0l2.1-1.6 3.4-2.6 6.9-5.2a7.6 7.6 0 0 0 2.7-8.7z" />
    <path fill="#FC6D26" d="m30.7 13-.1-.1a13.8 13.8 0 0 0-5.5 2.5L16 22.2l5.7 4.3 6.9-5.2a7.6 7.6 0 0 0 2.1-8.3z" />
    <path fill="#FCA326" d="m10.3 26.5 3.4 2.6 2.1 1.6a1.4 1.4 0 0 0 1.7 0l2.1-1.6 3.4-2.6-5.7-4.3z" />
    <path fill="#FC6D26" d="M6.9 15.4A13.8 13.8 0 0 0 1.4 13l-.1.1a7.6 7.6 0 0 0 2.2 8.3l6.9 5.2L16 22.2z" />
  </svg>
);

const AzureDevOpsLogo = ({ className = "" }) => (
  <svg viewBox="0 0 32 32" className={className} xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path fill="#0078D4" d="M30 7.6v16.6l-6.8 5.6-10.6-3.9v3.8L6.6 22l17.5 2V8.9L30 7.6zM24.2 9 14.3 3v3.9L5.2 9.6 2.5 13v7.8l3.9 1.7V12.4L24.2 9z" />
  </svg>
);

export function ProviderIcon({ provider, className = "h-4 w-4" }) {
  const p = (provider || "").toLowerCase();
  if (p === "github") return <GitHubLogo className={className} />;
  if (p === "gitlab") return <GitLabLogo className={className} />;
  if (p === "azure_devops") return <AzureDevOpsLogo className={className} />;
  return null;
}

export const brandColor = {
  azure: "#0078D4",
  aws: "#FF9900",
  gcp: "#4285F4",
  terraform: "#7B42BC",
  bicep: "#0078D4",
};
